import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import IMAGE from '../../services/image'

Vue.use(Vuex)

export default {
	state: {},
	actions: {
		[ACTIONS.IMAGE.IMAGE_INSTAGRAM]({ commit, dispatch, state }, shortCode) {
			return IMAGE.INSTAGRAM.IMAGE(shortCode).then(res => {
				return res
			})
		},
	},
}
